var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5654 29.8994H13.5781V38H11.1787V29.8994H8.24609V28.0469H16.5654V29.8994Z",
    fill: "#0075CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5406 38H18.148V28.0469H20.5406V38Z",
    fill: "#0075CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.008 34.623V38H22.6086V28.0469H26.5803C27.3413 28.0469 28.0135 28.1882 28.5969 28.4707C29.1848 28.7487 29.6382 29.1475 29.9572 29.667C30.2808 30.182 30.4426 30.7676 30.4426 31.4238C30.4426 32.3945 30.0939 33.1715 29.3967 33.7549C28.704 34.3337 27.7515 34.623 26.5393 34.623H25.008ZM25.008 32.7705H26.5803C27.0451 32.7705 27.3983 32.6543 27.6398 32.4219C27.8859 32.1895 28.009 31.8613 28.009 31.4375C28.009 30.9727 27.8837 30.6012 27.633 30.3232C27.3824 30.0452 27.0406 29.904 26.6076 29.8994H25.008V32.7705Z",
    fill: "#0075CA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9992 4.78536L8.99023 2.95972L11.7563 12.6151L34.9992 4.78536Z",
    fill: "#FF7500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0343 20.2332C13.0184 20.2332 13.0034 20.2371 12.9875 20.238C12.78 19.5822 12.6077 19.0342 12.6077 19.0342L7.57068 2.51656C7.57937 2.54083 7.58323 2.56413 7.58467 2.5884L7.56537 2.52287C7.56441 2.51899 7.56441 2.51608 7.56248 2.51316C7.41867 2.13503 6.90618 1.91853 5.84453 2.02872C4.78144 2.13891 4.96771 2.53452 5.11199 2.91315L12.0479 20.606C11.7208 20.887 11.5089 21.3001 11.5089 21.7676C11.5089 22.6146 12.1917 23.302 13.0343 23.302C13.8769 23.302 14.5592 22.6146 14.5592 21.7676C14.5592 20.92 13.8769 20.2332 13.0343 20.2332Z",
    fill: "#0075CA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.aafa990e3dc1c72bfd0fda7d84ded2d8.svg";
export { ForwardRef as ReactComponent };